import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail"]
  static values = {
    placementId: String,
    userId: String,
    isOpen: { type: Boolean, default: false }
  }

  connect() {
    console.log("✅ Tool placement detail controller connected", this.placementIdValue)
  }

  handleDetailClick(event) {
    // Close if clicking the backdrop area (not the white card)
    if (event.target === event.currentTarget) {
      console.log("🔵 Backdrop clicked, closing detail")
      this.close()
    }
    // Otherwise, let the event propagate to specific handlers (button clicks, etc)
  }

  toggle(event) {
    console.log("🔵 Toggle called")
    event.preventDefault()
    event.stopPropagation()

    this.closeAllOtherDetails()
    this.isOpenValue = !this.isOpenValue

    if (this.isOpenValue) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    console.log("Opening detail for placement:", this.placementIdValue)

    if (this.isMobile()) {
      document.body.style.overflow = 'hidden'
    }

    this.detailTarget.classList.remove("hidden")

    requestAnimationFrame(() => {
      this.detailTarget.classList.add("opacity-100")
      this.detailTarget.classList.remove("opacity-0", "-translate-y-2")

      if (!this.isMobile()) {
        this.detailTarget.classList.add("translate-y-0")
      }
    })

    if (!this.isMobile()) {
      setTimeout(() => {
        this.detailTarget.scrollIntoView({
          behavior: "smooth",
          block: "nearest"
        })
      }, 150)
    }
  }

  close(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    console.log("Closing detail for placement:", this.placementIdValue)

    this.isOpenValue = false
    document.body.style.overflow = ''

    this.detailTarget.classList.add("opacity-0", "-translate-y-2")
    this.detailTarget.classList.remove("opacity-100", "translate-y-0")

    setTimeout(() => {
      this.detailTarget.classList.add("hidden")
    }, 200)
  }

  removePlacement(event) {
    console.log('🔴 REMOVE PLACEMENT METHOD CALLED!')

    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const placementId = button.dataset.placementId
    const toolId = button.dataset.toolId
    const toolName = button.dataset.toolName
    const targetIndex = button.dataset.targetIndex
    const removeUrl = button.dataset.removeUrl

    console.log('=== removePlacement data ===')
    console.log('Placement ID:', placementId)
    console.log('Tool ID:', toolId)
    console.log('Tool name:', toolName)
    console.log('Target index:', targetIndex)
    console.log('Remove URL:', removeUrl)

    if (!removeUrl) {
      console.error('❌ Remove URL is missing!')
      return
    }

    if (!placementId) {
      console.error('❌ Placement ID is missing!')
      return
    }

    this.close()
    this.performRemove(removeUrl, placementId, toolId, toolName, targetIndex)
  }

  async performRemove(removeUrl, placementId, toolId, toolName, targetIndex) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    console.log('🚀 Starting remove request...')
    console.log('URL:', removeUrl)

    try {
      const response = await fetch(removeUrl, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({
          placement_id: placementId,
          tool_id: toolId,
          tool_name: toolName,
          target_index: parseInt(targetIndex)
        })
      })

      console.log('Remove response status:', response.status)

      if (response.ok) {
        const html = await response.text()
        console.log('✅ Turbo stream HTML received for removal')
        Turbo.renderStreamMessage(html)
      } else {
        console.error('❌ Failed to remove tool:', response.status)
        const text = await response.text()
        console.error('Response:', text)
      }
    } catch (error) {
      console.error('❌ Error removing tool:', error)
    }
  }

  closeAllOtherDetails() {
    const allControllers = document.querySelectorAll('[data-controller*="tool-placement-detail"]')

    allControllers.forEach(element => {
      const controller = this.application.getControllerForElementAndIdentifier(
        element,
        "tool-placement-detail"
      )

      if (controller && controller !== this && controller.isOpenValue) {
        controller.isOpenValue = false
        controller.close()
      }
    })
  }

  clickOutside(event) {
    if (this.isOpenValue && !this.element.contains(event.target)) {
      this.isOpenValue = false
      this.close()
    }
  }

  isMobile() {
    return window.innerWidth < 768
  }

  disconnect() {
    document.body.style.overflow = ''

    if (this.isOpenValue) {
      this.close()
    }
  }
}
